// extracted by mini-css-extract-plugin
module.exports = {"errorTitle":"styles_errorTitle__vWp9B","errorText":"styles_errorText__pBz3Y"};